import { MillwrightDaysSinceLastIncident } from '@/apis/incidents/types/incidentsApi';
import { DataItems } from '@/components';
import { formatDateString } from '@/utils';
import {
  BoxAppstore,
  Typography,
} from '@data-products-and-ai/react-components';
import { FC, useMemo } from 'react';

interface MillwrightLastAccidentsProps {
  data?: MillwrightDaysSinceLastIncident;
}

export const MillwrightLastAccident: FC<MillwrightLastAccidentsProps> = ({
  data: daysSinceIncident,
}) => {
  const dataItems = useMemo(
    () => [
      {
        key: 'date',
        label: 'Incident Date',
        value: (
          <Typography tag="textsmall_strong" color="var(--color-black)">
            {daysSinceIncident?.lastIncidentDate
              ? formatDateString(
                  daysSinceIncident.lastIncidentDate,
                  'MMMM Do, YYYY',
                )
              : 'N/A'}
          </Typography>
        ),
      },
      {
        key: 'incident',
        label: 'Days passed',
        value: (
          <Typography tag="textsmall_strong" color="var(--color-black)">
            {daysSinceIncident?.daysSinceLastIncident
              ? daysSinceIncident?.daysSinceLastIncident.toString()
              : 'N/A'}
          </Typography>
        ),
      },
    ],
    [daysSinceIncident],
  );

  if (!daysSinceIncident) return null;

  return (
    <BoxAppstore>
      <Typography tag="h4">Days Passed From Last Incident</Typography>
      <br />
      <DataItems items={dataItems} />
    </BoxAppstore>
  );
};
